export default "__VITE_PUBLIC_ASSET__40c5a368__"